import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

import Layout from "../../layout/default";
import Block from "../../components/Block/Block";
import instance from "../api";

function TaxSettings() {
  const [countriesData, setCountriesData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const countryColumns = [
    {
      name: "Country Name",
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
      style: {
        textAlign: "left",
      },
    },
    {
      name: "Collecting",
      selector: (row) => "Taxes",
      sortable: true,
      wrap: true,
      style: {
        textAlign: "left",
      },
    },
  ];

  const fetchData = async () => {
    try {
      const response = await instance.get(`api/Master/Country`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
          "ngrok-skip-browser-warning": "true",
        },
      });

      const activeCountries = response.data.rows.filter((c) => c.status === 1);

      setCountriesData(activeCountries);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRowClick = (row) => {
    navigate(`/taxcountry/${row.country_id}`);
  };

  const filteredCountries = countriesData.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout title="Countries List" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Tax Settings</Block.Title>
            {/* <nav>
                            <ol className="breadcrumb breadcrumb-arrow mb-0">
                                <li className="breadcrumb-item"><Link to="/home-ecommerce">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="">Countries Manage</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Countries</li>
                            </ol>
                        </nav> */}
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          <div className="p-3">
            <input
              type="text"
              placeholder="Search by Country Name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "30%",
                padding: "10px",
                borderRadius: "10px",
                border: "1px solid black",
                marginBottom: "10px",
              }}
            />
          </div>
          <DataTable
            columns={countryColumns}
            data={filteredCountries}
            pagination
            highlightOnHover
            pointerOnHover
            onRowClicked={handleRowClick}
            customStyles={{
              rows: {
                style: {
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#e6f7ff", // Light blue background on hover
                    transition: "background-color 0.3s ease", // Smooth transition
                  },
                },
              },
              headCells: {
                style: {
                  justifyContent: "flex-start !important", // Align header text to the left
                  backgroundColor: "#f1f1f1", // Highlight background color
                  fontWeight: "bold", // Bold text
                },
              },
              cells: {
                style: {
                  justifyContent: "flex-start !important", // Align cell text to the left
                },
              },
            }}
          />
        </Card>
      </Block>
    </Layout>
  );
}

export default TaxSettings;
